export default {"src":"/_next/static/media/Calender.0863b4f4.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};